var _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyStateNoSearchResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M157.072 130.913C133.779 130.913 116.5 149 113.423 159.81C110.346 170.62 110 172.947 110 177.5C110 196 102.5 197.944 97.5 198.5C79.5 200.5 70.1329 178.023 67.5 171C63.5634 160.5 61.5001 151.5 60.5001 140.5C58.5597 119.154 62.1008 103.342 72.0002 91.736C84.5636 77.0069 102.129 68.9915 124 72.4994C144.5 75.7874 159.751 85.6575 169.5 91.736C202 112 208.588 121.541 202.5 130.913C196.413 140.286 176.687 130.913 157.072 130.913Z",
    fill: "url(#paint0_linear_18982_50367)",
    fillOpacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M158.35 160.303C168.268 158.077 168.73 163.073 169.787 168.824C172.848 185.474 146.463 186.255 143.416 175.751C141.287 168.414 146.017 163.071 158.35 160.303Z",
    fill: "url(#paint1_linear_18982_50367)",
    fillOpacity: 0.15
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.288 78.6851C139.072 74.963 138.87 71.4778 140.15 68.5853C147.897 51.0722 171.694 54.2123 178.201 72.6349C183.481 87.5858 185.645 105.859 187.348 120.243C187.743 123.583 188.114 126.713 188.493 129.543C189.511 137.142 190.669 143.278 191.659 148.529C193.893 160.369 195.276 167.699 192.279 177.111C187.547 191.968 171.695 198.622 145.668 195.056C119.112 191.418 108.994 189.707 91.2486 183.765C76.4336 178.803 30.1396 161.164 35.4169 136.767C38.9863 120.266 53.7603 118.13 67.9853 116.074C70.6587 115.688 73.3127 115.304 75.8693 114.829C90.6748 112.074 103.493 109.094 110.863 107.38C111.443 107.245 111.989 107.118 112.5 107C140.552 100.496 139.87 88.7283 139.288 78.6851ZM153.549 69.9856C152.764 74.0461 156.078 78.1015 160.95 79.0435C165.823 79.9856 170.409 77.4576 171.195 73.3971C171.98 69.3366 168.666 65.2812 163.793 64.3392C158.921 63.3971 154.334 65.9251 153.549 69.9856Z",
    fill: "url(#paint2_linear_18982_50367)",
    fillOpacity: 0.07
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 216.563,
    cy: 134.563,
    rx: 6.29486,
    ry: 7.58822,
    transform: "rotate(20.6101 216.563 134.563)",
    fill: "url(#paint3_linear_18982_50367)",
    fillOpacity: 0.15
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 233.625,
    cy: 141.033,
    rx: 3.39985,
    ry: 4.09839,
    transform: "rotate(20.6101 233.625 141.033)",
    fill: "url(#paint4_linear_18982_50367)",
    fillOpacity: 0.15
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.7083,
    cy: 130.805,
    rx: 4.69515,
    ry: 6.57321,
    transform: "rotate(20.6101 24.7083 130.805)",
    fill: "url(#paint5_linear_18982_50367)",
    fillOpacity: 0.07
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.75 157.625C133.697 157.625 146.625 144.697 146.625 128.75C146.625 112.803 133.697 99.875 117.75 99.875C101.803 99.875 88.875 112.803 88.875 128.75C88.875 144.697 101.803 157.625 117.75 157.625ZM117.75 165.5C138.046 165.5 154.5 149.046 154.5 128.75C154.5 108.454 138.046 92 117.75 92C97.4535 92 81 108.454 81 128.75C81 149.046 97.4535 165.5 117.75 165.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.591 149.591C140.128 148.053 142.622 148.053 144.159 149.591L173.034 178.466C174.572 180.003 174.572 182.497 173.034 184.034C171.497 185.572 169.003 185.572 167.466 184.034L138.591 155.159C137.053 153.622 137.053 151.128 138.591 149.591Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18982_50367",
    x1: 127.115,
    y1: 191.902,
    x2: 70.6112,
    y2: 68.4626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18982_50367",
    x1: 160.094,
    y1: 181.388,
    x2: 142.782,
    y2: 164.846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18982_50367",
    x1: 108.836,
    y1: 188.638,
    x2: 47.1519,
    y2: 53.2629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18982_50367",
    x1: 216.115,
    y1: 141.347,
    x2: 208.074,
    y2: 128.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18982_50367",
    x1: 233.383,
    y1: 144.697,
    x2: 229.04,
    y2: 137.785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18982_50367",
    x1: 24.3738,
    y1: 136.682,
    x2: 17.0114,
    y2: 126.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoSearchResults);
export default __webpack_public_path__ + "static/media/emptyStateNoSearchResults.92153609.svg";
export { ForwardRef as ReactComponent };